// Haversine distance (km) between two lat/lng points.
export function haversineKm(lat1, lng1, lat2, lng2) {
  const R = 6371;
  const toRad = (d) => (d * Math.PI) / 180;
  const dLat = toRad(lat2 - lat1);
  const dLng = toRad(lng2 - lng1);
  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLng / 2) ** 2;
  return Math.round(R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a)));
}

// Coming weekend window [Friday 00:00, Sunday 23:59:59].
export function weekendRange(now = new Date()) {
  const day = now.getDay(); // 0 Sun .. 6 Sat
  const fri = new Date(now);
  if (day === 0) fri.setDate(now.getDate() - 2);
  else if (day === 6) fri.setDate(now.getDate() - 1);
  else fri.setDate(now.getDate() + (5 - day));
  fri.setHours(0, 0, 0, 0);
  const sun = new Date(fri);
  sun.setDate(fri.getDate() + 2);
  sun.setHours(23, 59, 59, 999);
  return { start: fri, end: sun };
}

// Event overlaps the weekend window (start or span).
export function isThisWeekend(event, range = weekendRange()) {
  if (!event.start_date) return false;
  const s = new Date(event.start_date);
  const e = event.end_date ? new Date(event.end_date) : s;
  return e >= range.start && s <= range.end;
}
